<h1 class="dg-primary-h2 mb-0 dg-txt-primary font-weight-bold fw-bold">
  {{ "partfile.create" | translate }}
</h1>
<!-- </br> -->
<!-- {{ "caseview_reference.Search" | translate }} -->
<br />
<!-- background-color: rgb(25, 92, 94); dg-primary-h2 mb-0 dg-txt-primary fw-bold
 Incoming Notings/Correspondence/Approved Drafts/Reference Files/Knowledge Bank-->
<div class="container-fluid">
  <mat-tab-group
    class="top-tab"
    #tabs
    mat-align-tabs="start"
    [(selectedIndex)]="selectedTabIndex"
  >
    <mat-tab label=" Notings">
      <div appStickyMenu class="row mt-2 sticky">
        <mat-card>
          <!-- <mat-expansion-panel
            class="mt-3"
            [expanded]="panelOpenState"
            (closed)="panelOpenState = false"
          > -->
          <!-- <mat-expansion-panel-header>
              <mat-panel-title class="dg-txt-primary dg-h-16 mb-2">
                Notings
              </mat-panel-title>
            </mat-expansion-panel-header> -->

          <mat-card>
            <div>
              <form>
                <div class="row">
                  <div>
                    <!-- <mat-form-field> </mat-form-field> -->
                    <h2 class="dg-primary-h2 mb-0 dg-txt-primary fw-bold">
                      {{ "partfile.Note for FileNo" | translate }} :
                      {{ fileno }}
                    </h2>
                    <h2 class="dg-primary-h2 mb-0 dg-txt-primary fw-bold">
                      {{ "partfile.Subject" | translate }} :
                      {{ subjectDescription }}
                    </h2>

                    <dynamic-grid
                      [rows]="rowsone"
                      [cols]="columnsone"
                      [showSearch]="false"
                      [showCheckboxForSelection]="showCheckboxForSelection"
                      [isRowSelectable]="isRowSelectable"
                      [allowMultiRowSelection]="allowMultiRowSelection"
                      [canAddRow]="canAddRow"
                      [gridFooterActions]="
                        gridFooterActionsConditionalFormatting
                      "
                      (onRowSelection)="onRowSelection($event)"
                      (onActionPerformed)="
                        onConditionalFormattingActionPerformed($event)
                      "
                    >
                    </dynamic-grid>
                    <!-- <dg-file-upload
                        [attachId]="attachId"
                        [multiple]="true"
                        [edit]="true"
                        [title]="'Upload File'"
                        [isPreview]="true"
                        [isComments]="true"
                        [allowMerging]="false"
                        [compactView]="true"
                        [allowUpdate]="false"
                        [allowFileToAttach]="false"
                        [allowDelete]="false"
                        [compressionEnable]="true"
                        (finalPath)="onFinalPath($event)"
                      >
                      </dg-file-upload> -->
                    <!--  [canEditInline]="false"
          [canAddRow]="!viewMode"
          [isEditable]="!viewMode"
          [pinColumn]="undefined"
          (onActionPerformed)="onActionPerformed($event)"-->
                    <!-- <dynamic-grid
                        [rows]="rows"
                        [cols]="columns"   [attachId]="notingAttachmentId"
                        [showSearch]="false"
                      >
                      </dynamic-grid> -->
                  </div>
                </div>
              </form>
            </div>
          </mat-card>
          <!-- </mat-expansion-panel> -->
        </mat-card>
      </div>
    </mat-tab>
    <mat-tab label="Correspondence">
      <!-- <app-agenda></app-agenda> -->

      <!-- <dynamic-grid [rows]="rowsone" [cols]="columnsone"> </dynamic-grid>#0df0ec; -->
      <div appStickyMenu class="row mt-2 sticky">
        <mat-card>
          <!-- <mat-expansion-panel
            class="mt-3"
            [expanded]="panelOpenState"
            (closed)="panelOpenState = false"
          > -->
          <!-- <mat-expansion-panel-header>
            <mat-panel-title
              class="dg-txt-primary dg-h-16 mb-2"
              style="padding: 1% 50% 1% 50%"
            >
              Incoming
            </mat-panel-title> -->
          <!-- background-color: #0df0ec; -->
          <!-- </mat-expansion-panel-header> -->

          <mat-card>
            <dg-grid
              #table
              [gridConfig]="gridConfig"
              (onLinkClick)="onClick($event)"
              (output)="getData($event)"
            >
            </dg-grid>
          </mat-card>
          <!-- </mat-expansion-panel> -->
        </mat-card>
      </div>
    </mat-tab>
    <mat-tab label="Approved Drafts">
      <!-- <app-agenda></app-agenda> -->

      <!-- <dynamic-grid [rows]="rowsone" [cols]="columnsone"> </dynamic-grid>#0df0ec; -->
      <div appStickyMenu class="row mt-2 sticky">
        <mat-card>
          <!-- <mat-expansion-panel
            class="mt-3"
            [expanded]="panelOpenState"
            (closed)="panelOpenState = false"
          >
            <mat-expansion-panel-header>
              <mat-panel-title
                class="dg-txt-primary dg-h-16 mb-2"
                style="padding: 1% 50% 1% 50%"
              >
                Outgoing
              </mat-panel-title>
              background-color: #0df0ec; 
            </mat-expansion-panel-header> -->

          <mat-card>
            <dg-grid
              #cmnGrid
              [gridConfig]="gridConfigone"
              (onLinkClick)="onClickone($event)"
              (output)="getDataone($event)"
            >
            </dg-grid>
          </mat-card>
          <!-- </mat-expansion-panel> -->
        </mat-card>
      </div>
    </mat-tab>

    <mat-tab label="Reference Files">
      <div appStickyMenu class="row mt-2 sticky">
        <mat-card>
          <!--  <mat-expansion-panel
            class="mt-3"
            [expanded]="panelOpenState"
            (closed)="panelOpenState = false"
          >
            <mat-expansion-panel-header>
              <mat-panel-title
                class="dg-txt-primary dg-h-16 mb-2"
                style="padding: 1% 50% 1% 50%"
                >ReferenceFiles</mat-panel-title
              >
            </mat-expansion-panel-header> -->

          <mat-card>
            <dg-grid
              #cmnGridone
              [gridConfig]="gridConfigtwo"
              (onLinkClick)="onClicktwo($event)"
              (output)="getSelectedDraftFromGridtwo($event)"
            >
            </dg-grid>
          </mat-card>
          <!-- </mat-expansion-panel> -->
        </mat-card>
      </div>
    </mat-tab>

    <mat-tab label="Knowledge Bank">
      <div appStickyMenu class="row mt-2 sticky">
        <mat-card>
          <mat-card>
            <dynamic-grid
              [rows]="rows"
              [cols]="columns"
              [showSearch]="false"
              [isRowSelectable]="isRowSelectable"
              [allowMultiRowSelection]="allowMultiRowSelection"
              [showCheckboxForSelection]="showCheckboxForSelection"
              [canAddRow]="canAddRow"
              (onRowSelection)="onRowSelectionone($event)"
              (onActionPerformed)="
                onConditionalFormattingActionPerformedOne($event)
              "
            ></dynamic-grid>
          </mat-card>
          <!-- </mat-expansion-panel> -->
        </mat-card>
      </div>
    </mat-tab>
  </mat-tab-group>
  <div class="mt-5 text-end">
    <!-- <div class="mt-auto text-end dg-btn"> -->
    <button
      class="dg-btn bttn"
      (click)="oncreate()"
      mat-flat-button
      color="primary"
    >
      Create
    </button>
    <button mat-flat-button mat-dialog-close (click)="closeTab.emit(true)">
      Close
    </button>
  </div>
</div>
